export default function getDefaultState () {
  return {
    error: null,
    inputFields: {
      email: '',
      password: ''
    }
  }
}
